(function() {
  console.log('🚀 Bag King Lightbox Gallery System: Active with Image Loading States');

  function initBkLightbox() {
    var lightboxOverlay = document.querySelector('.bk-lightbox-overlay');
    if (!lightboxOverlay) {
      lightboxOverlay = document.createElement('div');
      lightboxOverlay.className = 'bk-lightbox-overlay';
      lightboxOverlay.innerHTML = '<div class="bk-lightbox-content">' +
                                    '<span class="bk-lightbox-close">&times;</span>' +
                                    '<span class="bk-lightbox-nav bk-lightbox-prev">&#10094;</span>' +
                                    '<div class="bk-lightbox-loader"></div>' + // Spinner Element Added
                                    '<img id="bk-lightbox-image" src="" alt="Enlarged Packaging View">' +
                                    '<span class="bk-lightbox-nav bk-lightbox-next">&#10095;</span>' +
                                  '</div>';
      document.body.appendChild(lightboxOverlay);

      // Bind the native onload complete engine to clear the spinning loading sequence
      var lightboxImg = document.getElementById('bk-lightbox-image');
      if (lightboxImg) {
        lightboxImg.onload = function() {
          lightboxOverlay.classList.remove('bk-loading');
        };
      }
    }

    var currentGalleryImages = [];
    var currentActiveIndex = 0;

    function updateLightboxImage() {
      var lightboxImg = document.getElementById('bk-lightbox-image');
      if (lightboxImg && currentGalleryImages[currentActiveIndex]) {
        // Trigger loading state before network request begins
        lightboxOverlay.classList.add('bk-loading');
        lightboxImg.src = currentGalleryImages[currentActiveIndex];
      }
    }

    /*
     * MASTER CAPTURING ENGAGEMENT LAYER
     */
    document.body.addEventListener('click', function(e) {
      if (e.target.closest('.product__media-wrapper, media-gallery, [id*="zoom-dialog"], .product-media-container')) {
        return; 
      }

      var itemContainer = e.target.closest('.card, .card-wrapper, .grid__item, slideshow-slide, [class*="slide"], .carousel img');
      
      if (itemContainer) {
        var anchor = e.target.closest('a') || itemContainer.closest('a');
        if (anchor) {
          var href = anchor.getAttribute('href');
          if (href && href !== '#' && href.indexOf('#') !== 0 && href.indexOf('javascript') === -1) {
            return; 
          }
          e.preventDefault();
          e.stopImmediatePropagation();
        }

        var targetImg = itemContainer.tagName === 'IMG' ? itemContainer : itemContainer.querySelector('img');
        if (targetImg) {
          var structuralParent = itemContainer.closest('.carousel, [id*="Carousel"], [class*="carousel"], .grid, .slider, .shopify-section');
          currentGalleryImages = [];
          currentActiveIndex = 0;

          if (structuralParent) {
            var foundImages = structuralParent.querySelectorAll('img');
            foundImages.forEach(function(img) {
              var src = img.getAttribute('src');
              if (src && currentGalleryImages.indexOf(src) === -1) {
                currentGalleryImages.push(src);
              }
            });
            currentActiveIndex = currentGalleryImages.indexOf(targetImg.getAttribute('src'));
          } else {
            currentGalleryImages.push(targetImg.getAttribute('src'));
          }

          if (currentActiveIndex === -1) currentActiveIndex = 0;
          updateLightboxImage();
          lightboxOverlay.classList.add('bk-active');
        }
      }
    }, { capture: true, passive: false });

    /*
     * NAVIGATION & UI CLOSING INTERACTION HANDLERS
     */
    document.body.addEventListener('click', function(e) {
      if (!lightboxOverlay.classList.contains('bk-active')) return;

      if (e.target.classList.contains('bk-lightbox-next')) {
        currentActiveIndex = (currentActiveIndex + 1) % currentGalleryImages.length;
        updateLightboxImage();
        return;
      }

      if (e.target.classList.contains('bk-lightbox-prev')) {
        currentActiveIndex = (currentActiveIndex - 1 + currentGalleryImages.length) % currentGalleryImages.length;
        updateLightboxImage();
        return;
      }

      if (e.target.classList.contains('bk-lightbox-close') || e.target === lightboxOverlay) {
        lightboxOverlay.classList.remove('bk-active');
        lightboxOverlay.classList.remove('bk-loading');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (!lightboxOverlay.classList.contains('bk-active')) return;

      if (e.key === 'Escape') {
        lightboxOverlay.classList.remove('bk-active');
        lightboxOverlay.classList.remove('bk-loading');
      } else if (e.key === 'ArrowRight') {
        currentActiveIndex = (currentActiveIndex + 1) % currentGalleryImages.length;
        updateLightboxImage();
      } else if (e.key === 'ArrowLeft') {
        currentActiveIndex = (currentActiveIndex - 1 + currentGalleryImages.length) % currentGalleryImages.length;
        updateLightboxImage();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBkLightbox);
  } else {
    initBkLightbox();
  }
})();